<template>
  <div class="loading-page">
    <MyHeader />

    <div class="loading-cont width1200">
        
        <img src="../image/loading.png" alt="">
        <p>等待开始</p>
     
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import MyHeader from "@/components/MyHeader.vue";

export default {
  name: "Home",
  components: {
    MyHeader,
  },
};
</script>
<style lang="less" scoped src="../assets/common.less">
</style>
<style scoped lang="less">
.loading-page {
    .loading-cont {
height: 600px;
background: rgba(255, 255, 255, 0.5);
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
img {
    width: 100px;
height: 100px;
-webkit-transition-property: -webkit-transform;
    -webkit-transition-duration: 1s;
    -moz-transition-property: -moz-transform;
    -moz-transition-duration: 1s;
    -webkit-animation: rotate 3s linear infinite;
    -moz-animation: rotate 3s linear infinite;
    -o-animation: rotate 3s linear infinite;
    animation: rotate 3s linear infinite;
}
p {
    font-size: 32px;
color: #333333;
line-height: 46px;
font-weight: 600;
}
    }
}
@-webkit-keyframes rotate{from{-webkit-transform: rotate(0deg)}
    to{-webkit-transform: rotate(360deg)}
}
@-moz-keyframes rotate{from{-moz-transform: rotate(0deg)}
    to{-moz-transform: rotate(359deg)}
}
@-o-keyframes rotate{from{-o-transform: rotate(0deg)}
    to{-o-transform: rotate(359deg)}
}@keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(359deg)}
}
</style>
